import img1a from '../../../images/knbf-skjema/vannscooter/1a.webp';
import img2b from '../../../images/knbf-skjema/vannscooter/2b.webp';
import img3a from '../../../images/knbf-skjema/vannscooter/3a.webp';
import img3b from '../../../images/knbf-skjema/vannscooter/3b.webp';
import img3c from '../../../images/knbf-skjema/vannscooter/3c.webp';
import img3d from '../../../images/knbf-skjema/vannscooter/3d.webp';
import img3e from '../../../images/knbf-skjema/vannscooter/1a.webp';
import img3f from '../../../images/knbf-skjema/vannscooter/3f.webp';
import img3g from '../../../images/knbf-skjema/vannscooter/3g.webp';
import img3h from '../../../images/knbf-skjema/vannscooter/3h.webp';
import img3j from '../../../images/knbf-skjema/vannscooter/3j.webp';
import img4a from '../../../images/knbf-skjema/vannscooter/4a.webp';
import img4b from '../../../images/knbf-skjema/vannscooter/4b.webp';
import img4c from '../../../images/knbf-skjema/vannscooter/4c.webp';
import img4d from '../../../images/knbf-skjema/vannscooter/4d.webp';
import img4e from '../../../images/knbf-skjema/vannscooter/4e.webp';
import img4g from '../../../images/knbf-skjema/vannscooter/4g.webp';
import img5a from '../../../images/knbf-skjema/vannscooter/5a.webp';
import img5b from '../../../images/knbf-skjema/vannscooter/5b.webp';
import img5e from '../../../images/knbf-skjema/vannscooter/5e.webp';
import img8a from '../../../images/knbf-skjema/vannscooter/8a.webp';

const vannscooter = {
	title: 'Vannscooter',
	logo: 'knbf',
	formDescription: 'Sjekkliste for deg som kjører vannscooter',
	tableQuestions: [

		{header: '1. Forberedelser'},
		{text: 'A. Les deg opp, forstå og inspiser vannscooteren', legendIcon: 'b', modalContent: <p>Les og forstå
				sikkerhetsinformasjonen i instruksjonsboken og sikkerhetsmerkene på vannscooteren. Kontroller
				vannscooteren hver gang før du kjører for å oppdage eventuelle problemer som kan oppstå under bruk. Sørg
				for korrekt håndtering av vannscooteren.<img src={img1a}/></p>
		},

		{text: 'B. Ombordstigning på vannscooter', legendIcon: 'b', modalContent: <p>For å unngå skader er det viktig at fører og passasjerer leser og følger produsentens instruksjoner for hvordan man går om bord i vannscooteren fra en brygge, samt i grunt og dypt vann. Øv gjerne! To personer skal aldri gå om bord samtidig. Ombordstigning i dypt vann og grov sjø kan være krevende. Følg produsentens anvisninger for hvor man skal gripe tak, og hvilke steder man absolutt IKKE skal gripe tak i under ombordstigning, for å unngå skader. Motoren skal alltid være avslått før ombordstigning, og for å forhindre utilsiktet start skal man ALLTID koble fra ledningen til motorens stoppbryter!</p>},

		{text: 'C. Stuverom, ombordstigningsplattform og sete', legendIcon: 'b', modalContent: <p>Sørg for at hanskerommet, ombordstigningsplattformen, instrumentpanelet og setet er lukket og låst.</p>},

		{text: 'D. På vannet – kontroller instrumentering m.m.', legendIcon: 'b', modalContent: <p>Kontroller bremse- og reverssystemet (for eksempel kalt iBR) og det variable trimsystemet (VTS) etter at vannscooteren er sjøsatt og før du legger ut på tur. Motoren må være avslått, og nødstoppen/dødmannsgrepet skal være koblet fra motorens stoppbryter. Ikke start vannscooteren før alle punktene på sjekklisten er kontrollert og fungerer som de skal. Før du starter motoren og drar avgårde, anbefales det å riste den bakre delen av vannscooteren opp og ned for å fjerne sand som kan ha samlet seg i nærheten av fremdrifts- og reverssystemet.</p>},

		{header: '2. Er vannscooteren tett og fri for vann?'},

		{text: 'A. På land – skrogets utside', legendIcon: 'y', modalContent: <p>Kontroller at skroget er fritt for alvorlige skader.</p>},

		{text: 'B. På land – bunnplugg/lenseplugg (dersom det finnes)', legendIcon: 'y', modalContent: <p>Kontroller at
				den sitter godt fast før sjøsetting. Bunnpluggen kan være slitt eller sprukket. Noen har en pakning som
				bør kontrolleres årlig. Bytt ved behov.<img src={img2b}/></p>
		},

		{text: 'C. Bunnplate og vanninntak (inntaksgitter)', legendIcon: 'b', modalContent: <p>Kontroller at det ikke er skader på bunnplaten eller gitteret i vanninntaket.</p>},

		{header: '3. Sikkerhetsutstyr'},

		{text: 'A. Anker til vannscooter', legendIcon: 'm', modalContent: <p>Velg et gummibelagt anker, og sørg for at
				det er forsvarlig festet i stuverommet.<img src={img3a}/></p>
		},

		{text: 'B. Tau – vannscooter', legendIcon: 'b', modalContent: <p>For berging og fortøyning. Kontroller at tauet
				er lett tilgjengelig og ikke flokete.<img src={img3b}/></p>
		},

		{text: 'C. Brannslukker – vannscooter', legendIcon: 'm', modalContent: <p>Det anbefales at brannslukkeren finnes
				ombord og er plassert i sin holder. Bruk gummistropper for å feste brannslukkeren korrekt. Kontroller at
				manometeret står på grønt, at slangen er hel, at forseglingen er intakt, samt at datoen for siste
				kontroll eller utløpsdato er innenfor gyldig periode. Det kan være lurt å snu brannslukkeren noen ganger
				og banke lett på siden for å "lytte", slik at pulveret kan bevege seg fritt i slukkeren.<img
					src={img3c}/></p>
		},

		{text: 'D. Flytevester – vannscooter', legendIcon: 'b', modalContent: <p>Flytevester skal alltid finnes og
				brukes av alle ombord. Flytevestene skal være CE-merket. Bruk skrittsnoren hvis det finnes. Det finnes
				spesielle vester for vannsport som sitter på kroppen selv ved fall i høy fart.<img src={img3d}/></p>
		},

		{text: 'E. Kantring av vannscooter og kantringsdekal', legendIcon: 'b', modalContent: <p>Det er viktig at både
				fører og passasjerer leser og følger produsentens instruksjoner samt kantringsdekalene på akterspeilet.
				Når vannscooteren kantrer, vil den ikke automatisk vende seg tilbake. Dekalen på akterspeilet (som er
				opp ned for å kunne leses når vannscooteren har veltet) gir instruksjoner om hvordan man skal gå frem,
				og i hvilken retning den skal vendes for å komme tilbake til riktig kjøl. Ikke berør bunnplaten når den
				har mistet kontakten med vannet, da den kan være veldig varm og forårsake brannskader. Motoren skal
				alltid være avslått, og for å forhindre utilsiktet start skal man ALLTID koble fra kabelen til motorens
				stoppbryter før vannscooteren vendes tilbake til riktig kjøl.<img src={img3e}/></p>
		},

		{text: 'F. Klær for vannscooter – ikke kjør uten riktig bekledning!', legendIcon: 'b', modalContent:
				<p>Vannscooterførere skal bruke en godt tilpasset CE-merket flytevest som tåler fall over bord i høy
					fart. I tillegg er beskyttende klær nødvendig. Vanlige badeklær eller sykkelshorts gir ikke
					tilstrekkelig beskyttelse mot vann som med stor kraft kan trenge inn i kroppsåpninger (gjelder både
					menn og kvinner) ved baklengsfall i fart. Førere som ikke har brukt riktig bekledning har fått
					alvorlige anale, vaginale og indre skader som har ført til varige men, når de har falt av og havnet
					i vannstrålen. Det anbefales også å bruke hjelm, sko, hansker og beskyttelsesbriller.<img
						src={img3f}/></p>
		},

		{text: 'G. Lanternene – vannscooter', legendIcon: 'y', modalContent: <p>Vannscootere er normalt ikke utstyrt med
				lanterner og er ikke ment for bruk i mørket. Hvis det likevel finnes lanterner, kontroller at de
				fungerer og er riktig montert. Lanterne skal ikke blende føreren, og bør kontrolleres i mørket. Ekstra
				lyspære/LED-lampe anbefales.<img src={img3g}/></p>
		},

		{text: 'H. Sjøkart', legendIcon: 'b', modalContent: <p>Kontroller at det er oppdatert for den planlagte
				ruten.<img src={img3h}/></p>
		},
		{text: 'I. Tilbehør – ettermontering', legendIcon: 'm', modalContent: <p>Kontroller med forhandleren ved montering av tilbehør, da dette kan påvirke kjøreegenskapene samt ombordstigningen.</p>},
		{text: 'J. Vanntette poser', legendIcon: 'b', modalContent: <p>Anbefales!<img src={img3j}/></p>},

		{header: '4. Nødutstyr' },
		{
			text: 'A. Førstehjelpsskrin',
			legendIcon: 'm',
			modalContent: <p>I vanntett pose. Kontroller innholdet og siste forbruksdato.<img src={img4a}/></p>
		},
		{
			text: 'B. Nødsignal (håndbluss)',
			legendIcon: 'm',
			modalContent: <p>Ved ferdsel i områder med dårlig mobildekning og på åpent vann. Kontroller siste
				forbruksdato.<img src={img4b}/></p>
		},
		{
			text: 'C. Håndsøker/hodelykt',
			legendIcon: 'b',
			modalContent: <p>Ved ferdsel i mørket. Kontroller at de fungerer.<img src={img4c}/></p>
		},
		{
			text: 'D. Mobiltelefon',
			legendIcon: 'b',
			modalContent: <p>Vannbeskyttet og helst med GPS. Last ned SOS Alarm 112-appen og legg inn viktige
				telefonnumre. Det er viktig å kontrollere mobiloperatørens dekning.<img src={img4d}/></p>
		},
		{
			text: 'E. Nødsender',
			legendIcon: 'y',
			modalContent: <p>PLB (Personal Locator Beacon), SPOT (Satellite Personal Tracker), EPIRB (Emergency Position
				Indicating Radio Beacon). Bra å ha på åpent vann og i områder med dårlig mobildekning. OBS: Disse må
				være korrekt registrert for å fungere.<img src={img4e}/></p>
		},
		{
			text: 'F. Sikkerhetspakke',
			legendIcon: 'b',
			modalContent: <p>Medfølger ofte vannscooteren som ny, og inneholder for eksempel verktøy. Det anbefales at den finnes ombord, plassert i sin holder, og korrekt festet i oppbevaringsboksen.</p>
		},
		{
			text: 'G. Bærbar VHF',
			legendIcon: 'b',
			modalContent: <p>Bra å ha på ferdsel på åpent vann. Bærbar og vanntett. Før hver sesong bør funksjonen
				kontrolleres ved prøvesending, og håndteringen bør repeteres.<img src={img4g}/></p>
		},

		{header: '5. Fremdrift' },
		{
			text: 'A. Dødmannsgrep/sikkerhetsbryter',
			legendIcon: 'y',
			modalContent: <p>Hvis det finnes. Skal stoppe motoren hvis føreren faller over bord. Det er viktig at
				føreren har den tilkoblet, for eksempel rundt armen eller beinet. Kontroller at den fungerer. Et
				reservedelssett bør være lett tilgjengelig, slik at de som er igjen ombord kan starte motoren hvis
				føreren har falt over bord.<img src={img5a}/></p>
		},
		{
			text: 'B. Impeller',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong og bytt ved behov i henhold til motortilvirkerens anbefalinger.
				Ha en i reserve på lengre turer, for eksempel på åpent vann. Øv på å bytte impelleren før du trenger å
				gjøre det (ved innbordsmotor). Legg reserveimpelleren i en mørk, tett plastpose slik at gummiet ikke
				tørker ut for raskt.<img src={img5b}/></p>
		},
		{
			text: 'C. Jetpumpe vanninntak (inntaksgitter)',
			legendIcon: 'b',
			modalContent: <p>Nødstoppslina må alltid fjernes fra motorens stoppbryter før inntaksgitteret inspiseres. Fjern sjøgress, skjell, søppel eller annet som kan hindre vannstrømmen og skade drivverket. Rengjør etter behov.</p>
		},
		{
			text: 'D. Kjølevæskenivå',
			legendIcon: 'm',
			modalContent: <p>Kontroller/fyll på. Kontroller eventuelt kjølevæskelekkasje på motoren, i slanger og fra bunnplaten.</p>
		},
		{
			text: 'E. Motor',
			legendIcon: 'y',
			modalContent: <p>Serve motoren i henhold til instruksjonene fra motorleverandøren.<img src={img5e}/></p>
		},
		{
			text: 'F. Offeranoder for vannscooter',
			legendIcon: 'm',
			modalContent: <p>Kontroller flere ganger i løpet av sesongen og bytt ved behov. Kan finnes både på motoren og metalldeler på skroget og jetaggregatet. Kan også finnes i motorens kjølesystem.</p>
		},
		{
			text: 'G. Olje for vannscooter',
			legendIcon: 'b',
			modalContent: <p>Ved firetaktsmotor, kontroller ofte.</p>
		},

		{ header: '6. Drivstoffsystem' },
		{
			text: 'A. Drivstoff og drivstoffsystem',
			legendIcon: 'b',
			modalContent: <p>Fyll ikke på for mye drivstoff. Unngå drivstoffspill (tørk umiddelbart opp sølt drivstoff). Kontroller og sørg for at det ikke er lekkasjer eller bensindamp i motorrommet. Slå ikke på strømmen eller start vannscooteren hvis bensin eller lukt av bensindamp oppdages. Følg instruksjonene nøye ved påfylling av drivstoff!</p>
		},

		{ header: '7. Styreinnretning' },
		{
			text: 'A. Styring med kabler',
			legendIcon: 'y',
			modalContent: <p>Kontroller at kablene er i god stand og at de ikke går i for brå svinger.</p>
		},

		{ header: '8. Elektrisk anlegg' },
		{
			text: 'A. Batteri',
			legendIcon: 'm',
			modalContent: <p>Batteriet skal være godt festet, og ingen løse gjenstander som kan kortslutte polene skal
				være i samme rom. Sjekk for eventuell oksidasjon på polene. Rens og smør inn.<img src={img8a}/></p>
		}
	]
}

export default vannscooter